const Ribbon = ({ tagName, customClasses }) => {
  return (
    <span
      className={`ribbon absolute z-10 -rotate-6 inline-flex items-center bg-gradient-to-r from-accent-teal to-secondary-regular text-primary-dark font-work-sans font-semibold text-xs uppercase tracking-wide py-2 pl-5 pr-10 shadow-lg ${customClasses}`}
    >
      {/* <span className="w-1.5 h-1.5 rounded-full bg-primary-dark/70"></span> */}
      <p className="relative -top-[3px]">{tagName}</p>
    </span>
  );
};

export { Ribbon };
